import { createContext,useContext } from "react"
export const AuthContext = createContext({
    user: null,
    isAuthenticated: false,
    notification:[],
    updateState: () => {},
    setThemeColor:()=>{},
    themeColor:{
        color:"",
        colorRGB:""
    },
    socket:{}
   
   
})
export const useAuthContext = () => {
    return useContext(AuthContext)
}